import { FC } from 'react'
import { DatePicker } from '@cargomart/ui'

import s from './OrderFilterDateRange.module.less'

export interface OrderFilterDateRangeProps {
  departureDateFrom: string | null | undefined
  departureDateTo: string | null | undefined
  isLaptop: boolean
  onPickFrom: (date: string) => void
  onPickTo: (date: string) => void
}

export const OrderFilterDateRange: FC<OrderFilterDateRangeProps> = ({
  departureDateFrom,
  departureDateTo,
  isLaptop,
  onPickFrom,
  onPickTo
}) => (
  <div className={s.filterBodyDepartureDates}>
    {!isLaptop && <h2 className={s.filterBodyTitle}>Погрузка</h2>}
    <div className={s.departureDates}>
      <div className={s.departureDate}>
        <DatePicker
          isClearable
          className={s.datePicker}
          isWithCalendarIcon={isLaptop}
          onPick={onPickFrom}
          placeholder={isLaptop ? 'Погрузка' : ''}
          placement={isLaptop ? 'bottom' : 'right-start'}
          prefix={isLaptop ? undefined : <>От</>}
          value={departureDateFrom}
        />
      </div>
      <div className={s.departureDate}>
        <DatePicker
          className={s.datePicker}
          onPick={onPickTo}
          placeholder={isLaptop ? 'До' : ''}
          placement={isLaptop ? 'bottom' : 'right-start'}
          prefix={isLaptop ? <></> : <>До</>}
          value={departureDateTo}
        />
      </div>
    </div>
  </div>
)
